export const MuiMenuItem = () => ({
  styleOverrides: {
    root: {
      padding: '8px 24px 8px 16px'
    }
  }
})
